import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Modal, Button, Spinner } from 'react-bootstrap';
import DesignationForm from '../components/forms/DesignationForm';
import '../styles/EmployeeMaster.css';
import DesignationTable from '../components/DesignationTable';

const DesignationEditModel = () => {
     const baseUrl = process.env.REACT_APP_BASE_URL;
     const navigate = useNavigate();
     const location = useLocation();
     const { id } = useParams(); // ✅ Get ID from route

     const [designationData, setDesignationData] = useState(null);
     const [loading, setLoading] = useState(false);

     // ✅ Show modal only if URL starts with /sbu/edit
     const showModal = location.pathname.startsWith('/designation/edit');

     const handleCloseModal = () => {
          navigate('/designation'); // Go back to list
     };

     // ✅ Fetch SBU details by ID
     useEffect(() => {
          if (id && showModal) {
               setLoading(true);
               fetch(`${baseUrl}/getUserDesignById/${id}`)
                    .then(res => res.json())
                    .then(data => {
                         if (data.status) {
                              setDesignationData(data.data);
                         } else {
                              setDesignationData(null);
                         }
                         setLoading(false);
                    })
                    .catch(err => {
                         console.error('Error fetching Designation by ID:', err);
                         setLoading(false);
                    });
          }
     }, [id, showModal, baseUrl]);

     return (
          <div className="employee-master-page">
               <div className="employee-header">
                    <h2>Designation Master</h2>
               </div>

               {/* Table of SBUs */}
               <DesignationTable />

               {/* Edit Modal */}
               <Modal show={showModal} onHide={handleCloseModal} size="md" centered>
                    <Modal.Header closeButton className="py-2 px-3">
                         <Modal.Title style={{ fontSize: '18px', }}>Edit Designation</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="py-3 px-3">
                         {loading ? (
                              <div className="text-center my-3">
                                   <Spinner animation="border" size="sm" /> Loading...
                              </div>
                         ) : designationData ? (
                              <DesignationForm
                                   designationId={id}
                                   initialData={designationData}
                                   onSuccess={handleCloseModal}
                                   buttonSize="sm"
                              />
                         ) : (
                              <p className="text-center my-2">No data found for this SBU.</p>
                         )}
                    </Modal.Body>
                    <Modal.Footer className="py-2 px-3">
                         <Button variant="secondary" size="sm" onClick={handleCloseModal}>
                              Close
                         </Button>
                    </Modal.Footer>
               </Modal>
          </div>
     );
};

export default DesignationEditModel;
